import { CommonAxiosAPIHandler } from "common/helpers";
import { LOG_MODULES, LOG_CODE_PREFIX, trackException } from "common/errorTracker";

const ADD_NEW_MINI_TABLE_RECORD = "agent/addNewMiniTableRecord";
const UPDATE_MINI_TABLE_DETAILS = "agent/updateMiniTableDetails";

const pickMiniTableMeta = (payload) => ({
  miniTableDetailsID: payload.miniTableDetailsID,
  miniTableMaxRows: payload.miniTableMaxRows,
  areaID: payload.mlsAreaID,
  miniTableAddedDate: payload.miniTableAddedDate,
  miniTableUpdatedDate: payload.miniTableUpdatedDate,
  miniTableDoNotUpdate: payload.miniTableDoNotUpdate,
  miniTableStartDate: payload.miniTableStartDate,
  miniTableTitle: payload.miniTableTitle,
  miniTableSubTitle: payload.miniTableSubTitle,
  miniTableDisclaimer1: payload.miniTableDisclaimer1,
  miniTableDisclaimer2: payload.miniTableDisclaimer2,
  miniTableDisclaimer3: payload.miniTableDisclaimer3,
  miniTableDisclaimer4: payload.miniTableDisclaimer4,
  miniTableDateRange: payload.miniTableDateRange,
});

/**
 * Add a new property to the mini table.
 * Payload: miniTableDetailsID, mlsAreaID, property.
 */
export const AddMiniTableProperty = (payload) => {
  const body = {
    ...pickMiniTableMeta(payload),
    miniTable: [payload.property],
  };
  return CommonAxiosAPIHandler("POST", [ADD_NEW_MINI_TABLE_RECORD, body])
    .then((res) => {
      const property = res?.miniTable?.[0] ?? res?.property ?? payload.property;
      return { property };
    })
    .catch((err) => {
      trackException({
        module: LOG_MODULES.PMA_ADMIN,
        code: `${LOG_CODE_PREFIX.PMA}MINI_TABLE_ADD_FAILED`,
        error: err instanceof Error ? err : new Error(String(err)),
        data: { miniTableDetailsID: payload.miniTableDetailsID, areaID: payload.mlsAreaID },
      });
      throw err;
    });
};

/**
 * Update / delete / reorder: send full mini table.
 * Payload: miniTableDetailsID, mlsAreaID, miniTable.
 */
export const UpdateMiniTableDetails = (payload) => {
  const body = {
    ...pickMiniTableMeta(payload),
    miniTable: Array.isArray(payload.miniTable) ? payload.miniTable : [],
  };

  return CommonAxiosAPIHandler("POST", [UPDATE_MINI_TABLE_DETAILS, body])
    .then((res) => {
      return { miniTable: res?.miniTable ?? payload.miniTable, ...res };
    })
    .catch((err) => {
      trackException({
        module: LOG_MODULES.PMA_ADMIN,
        code: `${LOG_CODE_PREFIX.PMA}MINI_TABLE_SAVE_FAILED`,
        error: err instanceof Error ? err : new Error(String(err)),
        data: { miniTableDetailsID: payload.miniTableDetailsID, areaID: payload.mlsAreaID },
      });
      throw err;
    });
};
